import { ReactNode } from 'react';

import { Job, JobCompanyInfo } from '@kanda-libs/ks-frontend-services';

import JobQuoteContent from './Content';
import JobQuoteProvider from './context';

export type JobQuoteVariant = 'full' | 'collapsible' | 'compact';

export interface JobQuoteProps {
  job: Job | undefined;
  jobCompanyInfo: JobCompanyInfo | undefined;
  variant?: JobQuoteVariant;
  footer?: ReactNode;
  isLoading: boolean;
}

const JobQuote: React.FunctionComponent<JobQuoteProps> = function (props) {
  return (
    <JobQuoteProvider {...props}>
      <JobQuoteContent />
    </JobQuoteProvider>
  );
};

export default JobQuote;
